import adjustViewport from "@module/adjustViewport";
import smoothScroll from "@module/smoothScroll";
import toggleGnav from "@module/toggleGnav";
import fixFooterToBottom from "@module/fixFooterToBottom";
import initAOS from "@module/initAOS";
import fadeSlider from "@module/fadeSlider";
import headerChangeBg from "@module/headerChangeBg";
import topProjectSlider from "@module/topProjectSlider";
import blockContinuitySubmit from "@module/blockContinuitySubmit"; //フォーム連続送信防止
import FormDeleteInvalid from "@module/FormDeleteInvalid"; //フォームエラー表示

import '@scss/style.scss';

adjustViewport();
smoothScroll();
toggleGnav(true);
fixFooterToBottom();
initAOS();
fadeSlider();

// トップページ
if (document.body.id === 'top') {
    headerChangeBg();
    topProjectSlider();
    
// お問い合わせ
} else if (document.body.id === 'contact') {
    blockContinuitySubmit();
    FormDeleteInvalid();
}


